"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTitle = exports.IconLinkStyled = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
exports.IconLinkStyled = (0, styled_components_1.default)(react_router_dom_1.NavLink) `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: 426px) {
    margin: 1rem;
  }
`;
exports.IconTitle = styled_components_1.default.p `
  font-weight: 700;
  font-size: 1.125rem;
  margin: 0.5rem 0;
  border-bottom: 1px solid #7ceadb;
`;
